var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransparentArrow = function SvgTransparentArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1319"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    "data-name": "Ellipse 59"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 32.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.9 33.048 36.172 22.321a1.095 1.095 0 0 0-1.548 1.548l8.859 8.859H21.095a1.095 1.095 0 0 0 0 2.189h22.388l-8.859 8.858a1.095 1.095 0 1 0 1.548 1.548L46.9 34.597a1.1 1.1 0 0 0 0-1.549",
    "data-name": "Path 155"
  }))));
};
export default SvgTransparentArrow;